export { default } from "./AllottedTimeButtonGroup";
export type { AllottedTimeValue } from "./AllottedTimeButtonGroup";
